import { Outlet, Navigate } from 'react-router-dom';
import { Sidebar } from './Sidebar.js';
import { TopBar } from './TopBar.js';
import { BrandMark } from './Brand.js';
import { useSetupState } from '../lib/setupState.js';

/**
 * App layout. The sidebar is rendered FIRST so that in the RTL grid (`264px 1fr`) it lands in
 * track 1 — the RIGHT edge — and the main column flows to its left. This is the fix for the
 * mockup's left-side sidebar bug (RTL: nav belongs on the right).
 *
 * GATE: the whole app (Composer especially) stays LOCKED until onboarding is complete — a connected
 * number + a chosen control group + ≥1 target group (all from real data, useSetupState). While
 * incomplete we send the customer to the full-screen wizard at /welcome so "send message" can never
 * be reached before a number is even connected.
 */
export function AppShell(): JSX.Element {
  const setup = useSetupState();

  if (setup.loading) {
    return (
      <div className="wiz-screen">
        <div className="wiz-loading"><BrandMark size={30} /> <span className="wiz-spinner" /> טוען…</div>
      </div>
    );
  }
  if (!setup.complete) return <Navigate to="/welcome" replace />;

  return (
    <div className="app">
      <Sidebar />
      <div className="main">
        <TopBar />
        <Outlet />
        <footer style={{ padding: '20px 24px 26px', textAlign: 'center', fontSize: 12, color: 'var(--text-dim)' }}>
          <a href="/privacy" style={{ color: 'inherit', textDecoration: 'none' }}>מדיניות פרטיות</a>
          <span style={{ margin: '0 8px', opacity: 0.5 }}>·</span>
          <a href="/terms" style={{ color: 'inherit', textDecoration: 'none' }}>תקנון</a>
        </footer>
      </div>
    </div>
  );
}
